import { useEffect, useState } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { getOfflineAccountSnapshot } from '../../shell/session/offlineAccountCache';
import { awaitSessionBootstrap } from '../../shell/session/hydrateSessionCachesFromBootstrap';
import { resolveSessionEmployee } from '../application/sessionEmployeeResolver';
import { isDatabaseUnavailableError } from '../../shared/localDb';

/**
 * `true` / `false` si la consulta a Supabase respondi�.
 * `null` = a�n no sabemos (red error y sin cach� �til).
 */
export function useIsCurrentUserEmployee(): boolean | null {
  const session = useAuthStore((s) => s.session);
  const [value, setValue] = useState<boolean | null>(null);

  useEffect(() => {
    if (!session?.user?.id) {
      setValue(null);
      return;
    }
    const uid = session.user.id;
    let cancelled = false;

    (async () => {
      let snap = null;
      try {
        snap = await getOfflineAccountSnapshot(uid);
      } catch {
        /* ignore */
      }
      if (cancelled) return;
      if (snap && typeof snap.isEmployee === 'boolean') {
        setValue(snap.isEmployee);
      }

      try {
        await awaitSessionBootstrap(uid);
        const record = await resolveSessionEmployee(uid);
        if (cancelled) return;
        setValue(record.isEmployee);
      } catch (e) {
        if (!isDatabaseUnavailableError(e)) {
          console.warn('[useIsCurrentUserEmployee]', e);
        }
        if (snap && typeof snap.isEmployee === 'boolean') {
          setValue(snap.isEmployee);
        } else {
          setValue(null);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [session?.user?.id]);

  return value;
}
